import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';

import 'swiper/css/bundle';

export default () => {

	const els = [...document.querySelectorAll('.logo-carousel__row')]

	els.map(el => {

		const carouselEl = el.querySelector('.logo-carousel')
		const carouselPrev = el.querySelector('.swiper-carousel__prev')
		const carouselNext = el.querySelector('.swiper-carousel__next')

		if (!carouselEl) return null

		return new Swiper(carouselEl, {
			modules: [ Autoplay ],
			slidesPerView: 2.5,
			slidesPerGroup: 1,
			autoplay: {
				delay: 2000,
				disableOnInteraction: false,
			},
			effect: 'slide',
			speed: 900,
			freeMode: {
				enabled: true,
				sticky: true,
				momentum: true,
				momentumBounce: true,
			},
			loop: true,
			breakpoints: {
				780: { 
					slidesPerView: 3.75,
					slidesPerGroup: 1
				},
				1124: { 
					slidesPerView: 5.5,
					slidesPerGroup: 1
				},
				1650: { 
					slidesPerView: 7,
					slidesPerGroup: 1
				},
			},
		})
	})
}